var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['logo-container', { flipped: _vm.isFlipped }]},[_c('FilledLogo',{staticClass:"text-primary-default bambee-logo",class:[_vm.logoClass]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }